<template>
  <div class="order-answer">
    <ExerciseChart :chart="question.chart" :ticker="question.ticker" />
    <div class="order-answer__fields">
      <label v-for="field in fields" :key="field.key">
        {{ field.label }}
        <input inputmode="decimal" type="number" step="any" :value="value[field.key]" @input="update(field.key, $event.target.value)">
      </label>
    </div>
  </div>
</template>

<script>
import ExerciseChart from './ExerciseChart.vue';

export default {
  name: 'OrderTicketAnswer',
  components: { ExerciseChart },
  props: {
    question: { type: Object, required: true },
    value: { type: Object, default: () => ({}) }
  },
  data: () => ({
    fields: [
      { key: 'buy', label: 'Compra' },
      { key: 'resistance', label: 'Resistencia' },
      { key: 'support', label: 'Soporte' },
      { key: 'stop', label: 'Stop' }
    ]
  }),
  methods: {
    update(key, fieldValue) { this.$emit('input', { ...this.value, [key]: fieldValue }); }
  }
};
</script>

<style lang="scss" scoped>
.order-answer { display: grid; gap: 16px; }
.order-answer__fields { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
label { display: grid; gap: 7px; color: var(--modern-text); font-size: 13px; font-weight: 700; }
input { min-height: 46px; min-width: 0; padding: 0 12px; border: 1px solid var(--modern-border); border-radius: 11px; background: var(--modern-surface); color: var(--modern-text); font: inherit; }
@media (max-width: 520px) { .order-answer__fields { grid-template-columns: 1fr; } }
</style>
